package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets3 {
  internal val _13_yirmeyah_33_txt: AssetResource by lazy { init__13_yirmeyah_33_txt() }

  internal val _13_yirmeyah_34_txt: AssetResource by lazy { init__13_yirmeyah_34_txt() }

  internal val _13_yirmeyah_35_txt: AssetResource by lazy { init__13_yirmeyah_35_txt() }

  internal val _13_yirmeyah_36_txt: AssetResource by lazy { init__13_yirmeyah_36_txt() }

  internal val _13_yirmeyah_37_txt: AssetResource by lazy { init__13_yirmeyah_37_txt() }

  internal val _13_yirmeyah_38_txt: AssetResource by lazy { init__13_yirmeyah_38_txt() }

  internal val _13_yirmeyah_39_txt: AssetResource by lazy { init__13_yirmeyah_39_txt() }

  internal val _13_yirmeyah_40_txt: AssetResource by lazy { init__13_yirmeyah_40_txt() }

  internal val _13_yirmeyah_41_txt: AssetResource by lazy { init__13_yirmeyah_41_txt() }

  internal val _13_yirmeyah_42_txt: AssetResource by lazy { init__13_yirmeyah_42_txt() }

  internal val _13_yirmeyah_43_txt: AssetResource by lazy { init__13_yirmeyah_43_txt() }

  internal val _13_yirmeyah_44_txt: AssetResource by lazy { init__13_yirmeyah_44_txt() }

  internal val _13_yirmeyah_45_txt: AssetResource by lazy { init__13_yirmeyah_45_txt() }

  internal val _13_yirmeyah_46_txt: AssetResource by lazy { init__13_yirmeyah_46_txt() }

  internal val _13_yirmeyah_47_txt: AssetResource by lazy { init__13_yirmeyah_47_txt() }

  internal val _13_yirmeyah_48_txt: AssetResource by lazy { init__13_yirmeyah_48_txt() }

  internal val _13_yirmeyah_49_txt: AssetResource by lazy { init__13_yirmeyah_49_txt() }

  internal val _13_yirmeyah_50_txt: AssetResource by lazy { init__13_yirmeyah_50_txt() }

  internal val _13_yirmeyah_51_txt: AssetResource by lazy { init__13_yirmeyah_51_txt() }

  internal val _13_yirmeyah_52_txt: AssetResource by lazy { init__13_yirmeyah_52_txt() }

  internal val _14_yechezkel_01_txt: AssetResource by lazy { init__14_yechezkel_01_txt() }

  internal val _14_yechezkel_02_txt: AssetResource by lazy { init__14_yechezkel_02_txt() }

  internal val _14_yechezkel_03_txt: AssetResource by lazy { init__14_yechezkel_03_txt() }

  internal val _14_yechezkel_04_txt: AssetResource by lazy { init__14_yechezkel_04_txt() }

  internal val _14_yechezkel_05_txt: AssetResource by lazy { init__14_yechezkel_05_txt() }

  internal val _14_yechezkel_06_txt: AssetResource by lazy { init__14_yechezkel_06_txt() }

  internal val _14_yechezkel_07_txt: AssetResource by lazy { init__14_yechezkel_07_txt() }

  internal val _14_yechezkel_08_txt: AssetResource by lazy { init__14_yechezkel_08_txt() }

  internal val _14_yechezkel_09_txt: AssetResource by lazy { init__14_yechezkel_09_txt() }

  internal val _14_yechezkel_10_txt: AssetResource by lazy { init__14_yechezkel_10_txt() }

  internal val _14_yechezkel_11_txt: AssetResource by lazy { init__14_yechezkel_11_txt() }

  internal val _14_yechezkel_12_txt: AssetResource by lazy { init__14_yechezkel_12_txt() }

  internal val _14_yechezkel_13_txt: AssetResource by lazy { init__14_yechezkel_13_txt() }

  internal val _14_yechezkel_14_txt: AssetResource by lazy { init__14_yechezkel_14_txt() }

  internal val _14_yechezkel_15_txt: AssetResource by lazy { init__14_yechezkel_15_txt() }

  internal val _14_yechezkel_16_txt: AssetResource by lazy { init__14_yechezkel_16_txt() }

  internal val _14_yechezkel_17_txt: AssetResource by lazy { init__14_yechezkel_17_txt() }

  internal val _14_yechezkel_18_txt: AssetResource by lazy { init__14_yechezkel_18_txt() }

  internal val _14_yechezkel_19_txt: AssetResource by lazy { init__14_yechezkel_19_txt() }

  internal val _14_yechezkel_20_txt: AssetResource by lazy { init__14_yechezkel_20_txt() }

  internal val _14_yechezkel_21_txt: AssetResource by lazy { init__14_yechezkel_21_txt() }

  internal val _14_yechezkel_22_txt: AssetResource by lazy { init__14_yechezkel_22_txt() }

  internal val _14_yechezkel_23_txt: AssetResource by lazy { init__14_yechezkel_23_txt() }

  internal val _14_yechezkel_24_txt: AssetResource by lazy { init__14_yechezkel_24_txt() }

  internal val _14_yechezkel_25_txt: AssetResource by lazy { init__14_yechezkel_25_txt() }

  internal val _14_yechezkel_26_txt: AssetResource by lazy { init__14_yechezkel_26_txt() }

  internal val _14_yechezkel_27_txt: AssetResource by lazy { init__14_yechezkel_27_txt() }

  internal val _14_yechezkel_28_txt: AssetResource by lazy { init__14_yechezkel_28_txt() }

  internal val _14_yechezkel_29_txt: AssetResource by lazy { init__14_yechezkel_29_txt() }

  internal val _14_yechezkel_30_txt: AssetResource by lazy { init__14_yechezkel_30_txt() }

  internal fun values(): List<AssetResource> = listOf(_13_yirmeyah_33_txt, _13_yirmeyah_34_txt,
      _13_yirmeyah_35_txt, _13_yirmeyah_36_txt, _13_yirmeyah_37_txt, _13_yirmeyah_38_txt,
      _13_yirmeyah_39_txt, _13_yirmeyah_40_txt, _13_yirmeyah_41_txt, _13_yirmeyah_42_txt,
      _13_yirmeyah_43_txt, _13_yirmeyah_44_txt, _13_yirmeyah_45_txt, _13_yirmeyah_46_txt,
      _13_yirmeyah_47_txt, _13_yirmeyah_48_txt, _13_yirmeyah_49_txt, _13_yirmeyah_50_txt,
      _13_yirmeyah_51_txt, _13_yirmeyah_52_txt, _14_yechezkel_01_txt, _14_yechezkel_02_txt,
      _14_yechezkel_03_txt, _14_yechezkel_04_txt, _14_yechezkel_05_txt, _14_yechezkel_06_txt,
      _14_yechezkel_07_txt, _14_yechezkel_08_txt, _14_yechezkel_09_txt, _14_yechezkel_10_txt,
      _14_yechezkel_11_txt, _14_yechezkel_12_txt, _14_yechezkel_13_txt, _14_yechezkel_14_txt,
      _14_yechezkel_15_txt, _14_yechezkel_16_txt, _14_yechezkel_17_txt, _14_yechezkel_18_txt,
      _14_yechezkel_19_txt, _14_yechezkel_20_txt, _14_yechezkel_21_txt, _14_yechezkel_22_txt,
      _14_yechezkel_23_txt, _14_yechezkel_24_txt, _14_yechezkel_25_txt, _14_yechezkel_26_txt,
      _14_yechezkel_27_txt, _14_yechezkel_28_txt, _14_yechezkel_29_txt, _14_yechezkel_30_txt)
}

private fun init__13_yirmeyah_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-33.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-33.txt")

private fun init__13_yirmeyah_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-34.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-34.txt")

private fun init__13_yirmeyah_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-35.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-35.txt")

private fun init__13_yirmeyah_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-36.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-36.txt")

private fun init__13_yirmeyah_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-37.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-37.txt")

private fun init__13_yirmeyah_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-38.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-38.txt")

private fun init__13_yirmeyah_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-39.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-39.txt")

private fun init__13_yirmeyah_40_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-40.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-40.txt")

private fun init__13_yirmeyah_41_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-41.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-41.txt")

private fun init__13_yirmeyah_42_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-42.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-42.txt")

private fun init__13_yirmeyah_43_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-43.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-43.txt")

private fun init__13_yirmeyah_44_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-44.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-44.txt")

private fun init__13_yirmeyah_45_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-45.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-45.txt")

private fun init__13_yirmeyah_46_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-46.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-46.txt")

private fun init__13_yirmeyah_47_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-47.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-47.txt")

private fun init__13_yirmeyah_48_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-48.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-48.txt")

private fun init__13_yirmeyah_49_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-49.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-49.txt")

private fun init__13_yirmeyah_50_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-50.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-50.txt")

private fun init__13_yirmeyah_51_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-51.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-51.txt")

private fun init__13_yirmeyah_52_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_13_yirmeyah-52.txt\")") as String, rawPath =
    "allChapters/_13_yirmeyah-52.txt")

private fun init__14_yechezkel_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-01.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-01.txt")

private fun init__14_yechezkel_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-02.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-02.txt")

private fun init__14_yechezkel_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-03.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-03.txt")

private fun init__14_yechezkel_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-04.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-04.txt")

private fun init__14_yechezkel_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-05.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-05.txt")

private fun init__14_yechezkel_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-06.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-06.txt")

private fun init__14_yechezkel_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-07.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-07.txt")

private fun init__14_yechezkel_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-08.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-08.txt")

private fun init__14_yechezkel_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-09.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-09.txt")

private fun init__14_yechezkel_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-10.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-10.txt")

private fun init__14_yechezkel_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-11.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-11.txt")

private fun init__14_yechezkel_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-12.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-12.txt")

private fun init__14_yechezkel_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-13.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-13.txt")

private fun init__14_yechezkel_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-14.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-14.txt")

private fun init__14_yechezkel_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-15.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-15.txt")

private fun init__14_yechezkel_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-16.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-16.txt")

private fun init__14_yechezkel_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-17.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-17.txt")

private fun init__14_yechezkel_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-18.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-18.txt")

private fun init__14_yechezkel_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-19.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-19.txt")

private fun init__14_yechezkel_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-20.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-20.txt")

private fun init__14_yechezkel_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-21.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-21.txt")

private fun init__14_yechezkel_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-22.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-22.txt")

private fun init__14_yechezkel_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-23.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-23.txt")

private fun init__14_yechezkel_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-24.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-24.txt")

private fun init__14_yechezkel_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-25.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-25.txt")

private fun init__14_yechezkel_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-26.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-26.txt")

private fun init__14_yechezkel_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-27.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-27.txt")

private fun init__14_yechezkel_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-28.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-28.txt")

private fun init__14_yechezkel_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-29.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-29.txt")

private fun init__14_yechezkel_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_14_yechezkel-30.txt\")") as String, rawPath =
    "allChapters/_14_yechezkel-30.txt")

public actual val SharedRes.assets.allChapters._13_yirmeyah_33_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_33_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_34_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_34_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_35_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_35_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_36_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_36_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_37_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_37_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_38_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_38_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_39_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_39_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_40_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_40_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_41_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_41_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_42_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_42_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_43_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_43_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_44_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_44_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_45_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_45_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_46_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_46_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_47_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_47_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_48_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_48_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_49_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_49_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_50_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_50_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_51_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_51_txt

public actual val SharedRes.assets.allChapters._13_yirmeyah_52_txt: AssetResource
  get() = CommonMainAssets3._13_yirmeyah_52_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_01_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_01_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_02_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_02_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_03_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_03_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_04_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_04_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_05_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_05_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_06_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_06_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_07_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_07_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_08_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_08_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_09_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_09_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_10_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_10_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_11_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_11_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_12_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_12_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_13_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_13_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_14_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_14_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_15_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_15_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_16_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_16_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_17_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_17_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_18_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_18_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_19_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_19_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_20_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_20_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_21_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_21_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_22_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_22_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_23_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_23_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_24_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_24_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_25_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_25_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_26_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_26_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_27_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_27_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_28_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_28_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_29_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_29_txt

public actual val SharedRes.assets.allChapters._14_yechezkel_30_txt: AssetResource
  get() = CommonMainAssets3._14_yechezkel_30_txt
